import { useEffect } from 'react';
import LocalStorageService from '../../services/local-storage';
import usePendingApprovesStore from './store';

const usePendingApproves = () => {
  const notifications = usePendingApprovesStore((state) => state.notifications);
  const loadNotifications = usePendingApprovesStore(
    (state) => state.loadNotifications,
  );
  const hasLoaded = usePendingApprovesStore((state) => state.hasLoaded);
  const isLoading = usePendingApprovesStore((state) => state.isLoading);
  const loadError = usePendingApprovesStore((state) => state.loadError);

  useEffect(() => {
    const hasApiHostUrl = !!LocalStorageService.getItem('apiHostUrl');
    const hasToken = !!LocalStorageService.getItem('user')?.token;

    if (!hasApiHostUrl || !hasToken) {
      return;
    }

    if (hasLoaded || isLoading || loadError) {
      return;
    }

    loadNotifications().catch((error) => {
      console.error(error);
    });
  }, [hasLoaded, isLoading, loadError, loadNotifications]);

  return {
    notificationsCount: notifications.pendentes,
    notifications,
    loadNotifications,
    hasLoaded,
    isLoading,
    loadError,
  };
};

export default usePendingApproves;
